import { makeMutationForm } from 'components/makeMutationForm/makeMutationForm';
import { UpdateBankAccountFromBalanceScreenMutationVariables } from './UpdateBankAccount.generated';
import { rowErrorStrings } from './UploadBalance';

export const UpdateBankAccountForm = makeMutationForm<
  UpdateBankAccountFromBalanceScreenMutationVariables
>({
  config: {
    account_id: {
      type: 'hidden',
    },
    product_type: {
      type: 'bankAccountProductType',
    },
    account_description: {
      type: 'text',
    },
    fixed_maturity_date: {
      type: 'date',
    },
    opening_interest_rate: {
      type: 'number',
    },
    notice_days: {
      type: 'number',
    },
  },
  validate: (values) => {
    if (!values.product_type) {
      return {
        product_type: rowErrorStrings.noProductTypeProvidedOnAccount,
      };
    }
    if (!values.opening_interest_rate) {
      return {
        opening_interest_rate: rowErrorStrings.noInterestRate,
      };
    }
    if (values.product_type === 'FIXED' && !values.fixed_maturity_date) {
      return {
        fixed_maturity_date: rowErrorStrings.noFixedMaturityDateOnAccount,
      };
    }
    if (values.product_type === 'NOTICE' && !values.notice_days) {
      return {
        notice_days: rowErrorStrings.noNoticeDaysOnAccount,
      };
    }
  },
});
